import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import { isNil, trim, get, flatten, flattenDeep, range, omit, isArray } from "lodash-es";
import { Parser as HotParser } from "hot-formula-parser";
import { parse as pegParse } from "./pegParser";
import { StructTableKeywords } from "./common";
export var tokenize = function tokenize(expression) {
  if (isNil(expression)) {
    return [];
  }

  return flattenDeep(pegParse(trim("" + expression)));
};
export var simplifyTokens = function simplifyTokens() {
  var tokens = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var store = arguments[1];
  var rowIndex = arguments[2];
  var intraTableName = arguments[3];
  return tokens.map(function (token) {
    var tokenType = get(token, "type");
    if (!tokenType) return token;
    var node = store.findByName(token.name);
    if (!node) return null;

    if (tokenType === "node" && node.type === "formula") {
      return node.parsed.result;
    }

    if (tokenType === "node" && node.type === "table" || tokenType === "table") {
      var _ref = token.intraTableStruct || {},
          _ref$keywords = _ref.keywords,
          keywords = _ref$keywords === undefined ? [] : _ref$keywords,
          _ref$columns = _ref.columns,
          columns = _ref$columns === undefined ? [] : _ref$columns; // ToDo: support [#All] keyword


      if (columns.length === 0) {
        return null;
      }

      var _columns$map = columns.map(function (c) {
        return node.getColumnByName(c.name).index;
      }),
          start = _columns$map[0],
          end = _columns$map[1];

      var columnIndexRange = end && range(start, end + 1);

      if (keywords.length === 0) {
        keywords.push(StructTableKeywords.data);
      }

      if (keywords.length === 1) {
        var keyword = keywords[0];

        switch (keyword) {
          case StructTableKeywords.headers:
            {
              if (columnIndexRange) {
                return columnIndexRange.map(function (index) {
                  return JSON.stringify(node.columns[index].name);
                });
              }

              return JSON.stringify(node.columns[start].name);
            }

          case StructTableKeywords.totals:
            {
              if (columnIndexRange) {
                return columnIndexRange.map(function (index) {
                  return get(node.columns[index], "footerParsed.result") || null;
                });
              }

              return get(node.columns[start], "footerParsed.result") || null;
            }

          case StructTableKeywords.data:
            {
              if (columnIndexRange) {
                return columnIndexRange.map(function (index) {
                  return node.columns[index].getColumnCells().map(function (_ref2) {
                    var parsed = _ref2.parsed;
                    return isNil(parsed.result) ? 0 : parsed.result;
                  });
                });
              }

              var cells = node.columns[start].getColumnCells().map(function (_ref3) {
                var parsed = _ref3.parsed;
                return isNil(parsed.result) ? 0 : parsed.result;
              });

              if (!isNil(rowIndex) && node.name === intraTableName) {
                return cells[rowIndex];
              }

              return cells;
            }

          default:
            return null;
        }
      }
    }
  });
};
export var rename = function rename() {
  var expression = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var type = arguments[1];
  var oldName = arguments[2];
  var newName = arguments[3];
  var tableName = arguments[4];
  var tokens = tokenize(expression).map(function (token) {
    var tokenType = get(token, "type");
    if (!tokenType) return token;

    switch (tokenType) {
      case "node":
        {
          if (token.name === oldName) {
            return newName;
          }

          return token.name;
        }

      case "table":
        {
          if (type === "formula") {
            token.intraTableReference.map(function (structToken) {
              var structTokenType = get(structToken, "type");
              if (!structTokenType) return structToken;

              if (tokenType !== "node" || structToken.name !== oldName) {
                return structToken.name;
              }

              return newName;
            });
          }

          if (type === "column" && token.name === tableName) {
            var intraTableReferences = token.intraTableReference.map(function (structToken) {
              var structTokenType = get(structToken, "type");
              if (!structTokenType) return structToken;

              if (structTokenType !== "columnRange") {
                return structToken.name;
              }

              return structToken.tokens.map(function (t) {
                if (get(t, "type") !== "column") {
                  return t;
                }

                if (t.name !== oldName) {
                  return t.name;
                }

                return newName;
              });
            });
            var stringified = flatten(intraTableReferences).join("");
            return "" + token.name + stringified;
          }

          if (type === "table") {
            if (token.name === oldName) {
              return "" + newName + token.text.substring(oldName.length);
            }

            return token.text;
          }
        }
    }
  });
  return tokens.join("");
};
export var Parser = function (_HotParser) {
  _inherits(Parser, _HotParser);

  function Parser() {
    _classCallCheck(this, Parser);

    var _this = _possibleConstructorReturn(this, _HotParser.call(this));

    _this.setFunction("INDEX", function (_ref4) {
      var _ref4$ = _ref4[0],
          array = _ref4$ === undefined ? [] : _ref4$,
          index = _ref4[1];
      return array[index - 1];
    });

    _this.setFunction("ROWS", function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var array = get(args, 0);

      if (!isArray(array)) {
        return null;
      }

      return array.length;
    });

    _this.setFunction("FILTER", function (_ref5) {
      var _ref5$ = _ref5[0],
          column_to_return = _ref5$ === undefined ? [] : _ref5$,
          _ref5$2 = _ref5[1],
          column_to_compare = _ref5$2 === undefined ? [] : _ref5$2,
          _ref5$3 = _ref5[2],
          search_value = _ref5$3 === undefined ? "" : _ref5$3;
      var resultArray = [];
      column_to_compare.forEach(function (value, i) {
        if (value === search_value) {
          resultArray.push(column_to_return[i]);
        }
      });
      return resultArray;
    });

    return _this;
  }

  Parser.prototype.parseAsTokens = function parseAsTokens(tokens) {
    var _this2 = this;

    var tempVariables = [];

    var setTempVariable = function setTempVariable(name, value) {
      tempVariables.push(name);

      _this2.setVariable(name, value);
    };

    var expression = tokens.map(function (token, i) {
      if (isNil(token)) {
        return JSON.stringify(null);
      }

      if (isArray(token)) {
        var tempName = "reactivepad__arr_" + i;
        setTempVariable(tempName, flattenDeep(token));
        return tempName;
      }

      return "" + token;
    }).join("");
    var result = this.parse(expression);
    this.removeVariables(tempVariables);
    return result;
  };

  Parser.prototype.removeVariables = function removeVariables() {
    var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    this.variables = omit(this.variables, names);
  };

  return Parser;
}(HotParser);